import SendMessageInputComponent from "./SendMessageInputComponent";

export default SendMessageInputComponent;